import React from 'react'
import styled from 'styled-components'

export type NavLinkProps = {
    url: string
    title: string
}

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 20px;
    height: 100%;
`

const Link = styled.a`
    color: white;
    height: 100%;
    display: flex;
    align-items: center;
`

const NavLink = ({ url, title }: NavLinkProps) => {
    return (
        <Container>
            <Link href={url}>
                <span>{title}</span>
            </Link>
        </Container>
    )
}

export default NavLink
